<!-- @format -->

@if (favoritesEnabled()) {
	<shared-components-auth-snackbar [location]="FavoritesLocationEnum.PDP"></shared-components-auth-snackbar>
}

<ng-template #aboveTheFoldTemplate>
	<pdp-product-image-carousel
		[location]="dynamicTemplateToLoad()"
		[product]="product"
		[chainIdentifierAbbr]="chainIdentifierAbbr"
		[killSwitches]="killSwitches"
		[swatchColor]="defaultColor"
		[defaultCustomizedUrls]="
			(myCustomizerMap$ | async)?.imageURLs
		"></pdp-product-image-carousel>
</ng-template>
@if (useAboveTheFoldMobileContainer() && !isHybridPLA()) {
	<div class="hmf-display-md-none">
		<div
			class="carousel-initial-styles-{{ dynamicTemplateToLoad() }}"
			[class.is-pla-placeholder]="isPLAPlaceholderEnabled() && isPLA() && isPLAEnabled()"
			[ngClass]="{
				'is-pla': isSSRPLAEnabled() && isPLAEnabled() && isPLA() && !isPLADSCarouselEnabled()
			}">
			<ng-container #aboveTheFoldViewRef></ng-container>
		</div>
	</div>
}
<!-- TEMPORARY -- FOR DEVELOPMENT OF HYBRID PLA -->
@if (isHybridPLA()) {
	<pdp-hybrid-pla-product-details [product]="product"></pdp-hybrid-pla-product-details>
} @else {
	<div
		id="pdp-container"
		#templateOutlet></div>
}
